import { PolymerAxios } from './axios';
import { API_DownloadFile } from './api';
// https://polymer.hdb.decision-science.agency/transfer-api/polymer/application/downloadFile?key=polymer/c1e6665b-11e9-4c90-9535-4984594ba694/files/Code_Table.pdf
// https://polymer.hdb.decision-science.agency/transfer-api/polymer/application/downloadFile?key=polymer/c1e6665b-11e9-4c90-9535-4984594ba694/legal/_biome_screenshot91071673-1f85-4dc4-8c55-f3566cdf561d.jpg
const base64ToBlob = (base64: any, mime: any) => {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mime });
};

const fetchDataUrl = (url: string, fileName: string) => {
  const [prefix, base64Data] = url.split(';base64,');
  if (prefix.startsWith('data:')) {
    const mimeType = prefix.split(':')[1];
    const blob = base64ToBlob(base64Data, mimeType);
    const objectURL = URL.createObjectURL(blob);

    // // MIME types that should always download
    // const forceDownload = [
    //   'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
    //   'application/msword', // old Word
    //   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    //   'application/vnd.ms-excel', // old Excel
    //   'application/zip',
    // ];

    // if (forceDownload.includes(mimeType)) {
    //   // Download as file
    //   const link = document.createElement('a');
    //   link.href = objectURL;
    //   link.download = fileName;
    //   document.body.appendChild(link);
    //   link.click();
    //   link.remove();
    // } else {
    //   // Open directly in a new tab
    //   setTimeout(() => window.open(objectURL, '_blank'), 100);
    // }

    // 1️⃣ Force download with suggested filename
    const link = document.createElement('a');
    link.href = objectURL;
    link.download = fileName; // Suggested "Save As" name
    document.body.appendChild(link);
    link.click();
    link.remove();

    // 2️⃣ Auto-open in a new tab (works for PDFs/images)
    if (mimeType.startsWith('application/pdf') || mimeType.startsWith('image/')) {
      setTimeout(() => {
        window.open(objectURL, '_blank');
      }, 100);
    }

    // 3️⃣ Free memory after a short delay
    setTimeout(() => URL.revokeObjectURL(objectURL), 5000);
  } else {
    console.error('Invalid data URL:', url);
  }
};

interface DownloadFileOptions {
  callBack?: () => void;
  overrideFileName?: string;
}

export const downloadFile = (key: string, singpassToken: string = '', options: DownloadFileOptions = {}) => {
  const extension_type = key.split('.').pop()?.toLowerCase();

  // Default type: PDF instead of generic octet-stream
  let type = 'application/pdf';

  switch (extension_type) {
    // PDF
    case 'pdf':
      type = 'application/pdf';
      break;

    // Images
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'gif':
      type = `image/${extension_type}`;
      break;

    // Word
    case 'docx':
      type = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      break;
    case 'doc':
      type = 'application/msword';
      break;

    // If no match, leave as PDF
    default:
      type = 'application/pdf';
      break;
  }

  
  //CHANGE TO POST on OCT 3rd, Local swagger Docs showing GET.
  //CHANGE query param from `key` to `file` on OCT 3rd.
  PolymerAxios('', singpassToken)
    .post(`${API_DownloadFile}?file=${key}`, {})
    .then((res) => {
      try {
        //NOTE: data is base 64 string return from api
        const { file_name: fileName, data } = res.data;
        const url = `data:${type};base64,${data}`;
        
        const clientFilename = options?.overrideFileName ?? fileName
        fetchDataUrl(url, clientFilename);
      } catch (e) {
        alert('An error occurred while downloading the file. Please try again later.');
      }
    })
    .catch((e) => {
      console.log('get download file catch', e);
      alert('An error occurred while downloading the file. Please try again later.');
    })
  .finally(() => {
    if (options?.callBack) {
      options?.callBack();
    }
  });
};
